import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { LeadForm } from "./LeadForm";

export function EnquiryDialog({ settings }) {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState({});
  useEffect(() => {
    const h = (e) => { setPrefill(e.detail || {}); setOpen(true); };
    window.addEventListener("blc:enquiry", h);
    return () => window.removeEventListener("blc:enquiry", h);
  }, []);
  if (!settings) return null;
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md w-[calc(100%-1.5rem)] sm:w-full rounded-[28px] max-h-[92vh] overflow-y-auto" data-testid="enquiry-dialog">
        <DialogHeader>
          <DialogTitle className="text-2xl font-extrabold tracking-[-0.03em]">Check my options</DialogTitle>
        </DialogHeader>
        <LeadForm settings={settings} prefill={prefill} variant="dialog" onDone={() => {}} />
      </DialogContent>
    </Dialog>
  );
}
